import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { SectionCTA } from './SectionCTA';
export function WhatYouLearn() {
  const points = ['Hoe je de "Verborgen Handleiding" van je hond vindt, zodat jullie beter samenwerken dan ooit.', 'Wat dé sleutel is tot een harmonieus en ontspannen leven samen met je hond.', 'Welke mythes en miscommunicaties ongemerkt jullie vertrouwensband kunnen schaden (en hoe je deze makkelijk voorkomt).', 'Hoe honden écht in elkaar zitten, waardoor jij ze voortaan beter begrijpt dan 90% van de hondeneigenaren.', 'Hoe je probleemsituaties totaal anders kan laten verlopen en voortaan voorkomt—zonder te corrigeren, straffen of commanderen.', 'Hoe je de taal van je hond vloeiend leert spreken en hem of haar nóg gelukkiger maakt.'];
  return <section className="bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-177">
      <div className="max-w-4xl mx-auto" data-id="element-178">
        <div className="text-center mb-12" data-id="element-179">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-800 mb-4" data-id="element-180">
            Tijdens deze gratis 90-minuten training ontdek je:
          </h2>
          <div className="w-24 h-1 bg-brand-mint mx-auto rounded-full opacity-50" data-id="element-181"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-182">
          {points.map((point, index) => <div key={index} className="flex items-start gap-4 p-6 rounded-2xl bg-gray-50 border border-gray-100 hover:border-brand-mint/30 transition-colors duration-300" data-id="element-183">
              <div className="flex-shrink-0 mt-1" data-id="element-184">
                <CheckCircle2 className="w-6 h-6 text-brand-mint" data-id="element-185" />
              </div>
              <p className="text-gray-700 leading-relaxed font-medium" data-id="element-186">
                {point}
              </p>
            </div>)}
        </div>

        <SectionCTA data-id="element-187" />
      </div>
    </section>;
}